// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Overlay INSTEAD.
import React from 'react';
import { PropTypes } from 'prop-types';
export default function UUOverlay(props) {
  if (!props.open) {
    return null;
  }
  var overlayClass = 'fixed inset-0 bg-black bg-opacity-40 z-1400';
  return /*#__PURE__*/React.createElement("div", {
    className: overlayClass,
    onClick: props.onClick,
    role: "presentation"
  }) // cursor-default
  ;
}
UUOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};